var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.plateList),function(item){return _c('plate',{key:item.SnapshotID,attrs:{"plateNo":_vm.row.PlateNo,"plate":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }